import React, {FC} from 'react';
import {Alert} from 'reactstrap';

import CommonWorktagsLayout from '../layout/common-worktags-layout';

export const CommonWorktagsPage: FC = () => {

        return (
            <div className="d-flex flex-column nh-100">
                <div className="flex-grow-1 d-flex flex-column">
                    <Alert color="warning">
                        Worktags are case sensitive and must be
                        entered exactly as they are entered in Workday
                    </Alert>
                    <CommonWorktagsLayout />
                </div>
            </div>
        );
}

export default CommonWorktagsPage;
